import React from "react";
import { Select } from "antd";

export default class OriginatorsSelector extends React.Component {

  onChange = selectedVal =>{
    if(selectedVal.length==0) {
      this.props.onChange([])
    } else {
    let originatorsSelected = [];
    selectedVal.forEach(item => {
      let filterItem = this.props.originators.find(subItem => subItem.id == item.key);
      if(filterItem) {
        originatorsSelected.push(filterItem)
      }
    })
    this.props.onChange(originatorsSelected)
    }
  }

  render() {

    const originators = this.props.originators;
    const value = this.props.defaultValue;
    let valueStr=[];
    if(value && value.length > 0) {
      for(let obj of value) {
        let originatorName="";
        let originatorItem = originators.find(item => item.id === obj.id);
        if(originatorItem) {
          if (originatorItem.originatorType === 'CORPORATE') {
            originatorName = originatorItem.businessName;
          } else {
            originatorName = originatorItem.lastName + ", " + originatorItem.firstName;
          }
          valueStr.push({key: originatorItem.id,id:originatorItem.id, label: originatorName});
        }
      }
    }

    return (
      <Select
        {...this.props}
        mode={this.props.mode || "default"}
        size={this.props.size}
        labelInValue={true}
        style={{fontSize: 16, ...this.props.style }}
        value={valueStr}
        onChange={this.onChange}
      >
        {originators.map((originator, idx) => {
          return (
              <Select.Option value={originator.id} key={originator.id} label={originator.displayName}>
                {originator.displayName}
              </Select.Option>
          );
        })}
      </Select>
    );
  }
}
